import React from 'react';
import { Button, Input, Popover, useToasts } from 'freemium-ui';
import { yupResolver } from '@hookform/resolvers/yup';
import { get, uniq } from 'lodash';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { CustomFilterViewContainer } from 'routes/screens/contacts/components/FilterViews/styles';
import { useGetSegments, useSaveSegment } from 'routes/screens/segments/hooks';
import { MiniFormHeader } from 'shared/styles';
import { RuleType, SegmentType } from 'shared/types';
import { useAccessControl } from 'utils/access-control';

type FilterSegmentProps = {
  rule?: RuleType;
  isFilterConditionsModified?: boolean;
};

export const FilterSegment = (props: FilterSegmentProps) => {
  const { rule, isFilterConditionsModified } = props;
  const [anchorEl, setAnchorEl] = React.useState<any>(null);
  const [, setToast] = useToasts();
  const { push } = useHistory();
  const { t } = useTranslation();
  const { access = [] } = useAccessControl();

  const { data: segmentsData = {} } = useGetSegments();

  const [takenNames, setTakenNames] = React.useState<string[]>([]);

  React.useEffect(() => {
    const newNames = (segmentsData?.segment_rules || [])
      .map((segment) => segment.name || '')
      .filter((v) => !!v);
    setTakenNames((old) => uniq([...old, ...newNames]));
  }, [segmentsData]);

  const form = useForm<SegmentType>({
    resolver: (formValues: SegmentType, ...resolverProps) => {
      return yupResolver(
        Yup.object({
          id: Yup.string(),
          version: Yup.string(),
          name: Yup.string()
            .required(`${t('forms.err_msg.segment_required')}`)
            .trim()
            .max(
              50,
              `${t('forms.err_msg.max_char', {
                len: '50',
              })}`,
            )
            .min(
              3,
              `${t('forms.err_msg.min_char', {
                len: '3',
              })}`,
            )
            .test({
              message: 'Error',
              name: 'name',
              test: function (name, context) {
                const { createError } = context || {};
                if (takenNames.includes(name || '')) {
                  return createError({
                    message: `${t('forms.err_msg.segment_exists', {
                      name: name,
                    })}`,
                  });
                }
                return true;
              },
            }),
        }).required(),
      )(formValues, ...resolverProps);
    },
  });

  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = form;

  const { mutate: saveSegment } = useSaveSegment({
    setToast,
    callback: (
      isSuccess: boolean,
      response: SegmentType,
      payload: SegmentType,
    ) => {
      if (isSuccess && !payload?.id) {
        push('/segments');
      }
    },
  });
  const onSave = () => {
    const payload: SegmentType = {
      rule: rule,
      name: watch('name'),
      entity: 'CONTACT',
      segment_type: 'RULE_BASED',
    };
    saveSegment(payload);
  };
  return (
    <div>
      <MiniFormHeader>
        <div>{`${t('filters')} ${isFilterConditionsModified ? '*' : ''}`}</div>
        {access.indexOf('contact:write') > -1 && isFilterConditionsModified && (
          <>
            <div
              className="segment-filter"
              onClick={(e) => setAnchorEl(e.currentTarget)}
              aria-describedby="filter-segment-popover"
            >
              {t('forms.filter_view.save_segment_view')}
            </div>
            <Popover
              id="filter-segment-popover"
              anchorEl={anchorEl}
              onClose={() => {
                setAnchorEl(null);
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <CustomFilterViewContainer>
                <div className="header">
                  {t('forms.filter_view.save_segment_as')}
                </div>
                <Input
                  autoFocus
                  {...register('name')}
                  maxLength={50}
                  onClick={(e: any) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  isErrored={!!get(errors, ['name', 'message'], '')}
                  errorText={get(errors, ['name', 'message'], '')}
                />
                <div className="filter-view-options">
                  <Button inline htmlType="reset" type="secondary">
                    {t('cancel')}
                  </Button>
                  <Button
                    inline
                    htmlType="submit"
                    onClick={(e) => {
                      if (errors) {
                        e.preventDefault();
                        e.stopPropagation();
                      }
                      handleSubmit(onSave, (err) => console.log('ERR', err))();
                    }}
                  >
                    {t('save')}
                  </Button>
                </div>
              </CustomFilterViewContainer>
            </Popover>
          </>
        )}
      </MiniFormHeader>
    </div>
  );
};
